import * as types from '../constants/ActionTypes';

export function setDeparturePort(portCode, portId, portLabel) {
  return {
    type: types.SET_DEPARTURE,
    portCode,
    portId,
    portLabel
  }
}

export function setArrivalPort(portCode, portId, portLabel) {
  return {
    type: types.SET_ARRIVAL,
    portCode,
    portId,
    portLabel
  }
}

export function setDepartureList(departureList) {
  return {
    type: types.SET_DEPARTURE_LIST,
    departureList,
  }
}

export function setArrivalList(arrivalList) {
  return {
    type: types.SET_ARRIVAL_LIST,
    arrivalList,
  }
}

export function setStartDate(startDate) {
  return {
    type: types.SET_START_DATE,
    startDate,
  }
}

export function setEndDate(endDate) {
  return {
    type: types.SET_END_DATE,
    endDate,
  }
}

export function setDates(startDate, endDate) {
  return {
    type: types.SET_DATES,
    startDate,
    endDate,
  }
}

export function setIsRoundTrip(isRoundTrip) {
  return {
    type: types.SET_IS_ROUND_TRIP,
    isRoundTrip,
  }
}

// -----------------------------------------------ITINERARIES -----------------------------------------

export function setOutgoingTrips(tripList) {
  return {
    type: types.SET_OUTGOING_TRIPS,
    tripList,
  }
}

export function setIncomingTrips(tripList) {
  return {
    type: types.SET_INCOMING_TRIPS,
    tripList,
  }
}

export const setOutgoingDestinationTrips = (tripList) => ({
  type: types.SET_OUTGOING_DESTINATION_TRIPS,
  tripList
});

export const setIncomingDestinationTrips = (tripList) => ({
  type: types.SET_INCOMING_DESTINATION_TRIPS,
  tripList
});

export function setSelectedOutgoingTrip(outgoingTrip) {
  return {
    type: types.SELECT_OUTGOING_TRIP,
    outgoingTrip,
  }
}

export function setSelectedIncomingTrip(incomingTrip) {
  return {
    type: types.SELECT_INCOMING_TRIP,
    incomingTrip,
  }
}

export function setSearchParameters(searchStartDay, searchEndDay, searchDeparturePortCode,  searchArrivalPortCode ) {
  return {
    type: types.SET_SEARCH_PARAMETERS,
    searchStartDay,
    searchEndDay,
    searchDeparturePortCode,
    searchArrivalPortCode,


  }
}

export function setUserSelectedDepartureTrip(hasUserSelectedDepartureTrip) {
  return {
    type: types.SET_USER_SELECTED_DEPARTURE_TRIP,
    hasUserSelectedDepartureTrip: hasUserSelectedDepartureTrip
  }
}

export function setUserSelectedReturnTrip(hasUserSelectedReturnTrip) {
  return {
    type: types.SET_USER_SELECTED_RETURN_TRIP,
    hasUserSelectedReturnTrip: hasUserSelectedReturnTrip,
  }
}


// -----------------------------------------------ALL AGENCIES -----------------------------------------


export function setAgencyCountryId(countryId) {
  return {
    type: types.SET_AGENCIES_COUNTRY_ID,
    countryId: countryId,
  }
}

export function setAgencyPerfectureId(perfectureId) {
  return {
    type: types.SET_AGENCIES_PERFECTURE_ID,
    perfectureId: perfectureId,
  }
}

export function setAgencyMunicipalityId(municipalityId) {
  return {
    type: types.SET_AGENCIES_MUNICIPALITY_ID,
    municipalityId: municipalityId,
  }
}

export function setAgenciesList(agenciesList) {
  return {
    type: types.SET_AGENCIES_LIST,
    agenciesList: agenciesList,
  }
}

// -----------------------------------------------TRIP AGENCIES -----------------------------------------


export function setTripAgencyCountryId(countryId) {
  return {
    type: types.SET_TRIP_AGENCIES_COUNTRY_ID,
    countryId: countryId,
  }
}

export function setTripAgencyPerfectureId(perfectureId) {
  return {
    type: types.SET_TRIP_AGENCIES_PERFECTURE_ID,
    perfectureId: perfectureId,
  }
}

export function setTripAgencyMunicipalityId(municipalityId) {
  return {
    type: types.SET_TRIP_AGENCIES_MUNICIPALITY_ID,
    municipalityId: municipalityId,
  }
}

export function setTripAgenciesList(agenciesList) {
  return {
    type: types.SET_TRIP_AGENCIES_LIST,
    agenciesList: agenciesList,
  }
}

// -----------------------------------------------ALL EVENTS -----------------------------------------

export function setEventsLocationCode(locationCode) {
  return {
    type: types.SET_EVENTS_LOCATION_CODE,
    locationCode: locationCode,
  }
}

export function setEventsEventtypeId(eventTypeId) {
  return {
    type: types.SET_EVENTS_EVENTTYPE_ID,
    eventTypeId: eventTypeId,
  }
}

export function setEventsMaxeventsSize(maxEventsSize) {
  return {
    type: types.SET_EVENTS_MAXEVENTS_SIZE,
    maxEventsSize: maxEventsSize,
  }
}
export function setDate(date) {
  return {
    type: types.SET_EVENTS_DATE,
    date: date,
  }
}

export function setEventsList(eventsList) {
  return {
    type: types.SET_EVENTS_LIST,
    eventsList: eventsList,
  }
}

// ----------------------------------------------- TRANSLATION -----------------------------------------

export function setLanguage(language) {
  return {
    type: types.CHANGE_LANGUAGE,
    language: language,
  }
}


// WEBPACK FOOTER //
// ./src/actions/index.js